import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import { Routes, Screens } from '../utils/Routes';

import * as Actions from '../actions/whatsNewDetail';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/WhatsNewDetailScenarioFactory';

const styles = (theme: Theme) =>
	createStyles({
		buttons: {
			marginTop: theme.spacing(1),
		},
		message: {
			marginTop: theme.spacing(3),
			overflowWrap: 'break-word',
			padding: theme.spacing(2),
			wordWrap: 'break-word',
		},
		messageBody: {
			background: `radial-gradient(transparent, ${theme.palette.primary
				.main + '10'})`,
			borderRadius: theme.spacing(2),
			marginTop: theme.spacing(3),
			padding: theme.spacing(2),
		},
		root: {
			padding: theme.spacing(2),
		},
		wordBreak: {
			display: 'block',
			wordBreak: 'break-word',
		},
	});

/**
 * What's New一覧
 */
class MessageDetail extends React.Component<IProps> {
	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.props.fetchWhatsNews(this.props.token);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.clearWhatsNewList();
	}

	public render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				{this.props.whatsNews.map(w => (
					<Paper key={w.messageID} className={classes.message}>
						<Typography
							variant="caption"
							className={this.props.classes.wordBreak}
						>
							{w.startDateStr}
						</Typography>
						{w.titleList.map((title, i) => (
							<React.Fragment key={i}>
								<span
									dangerouslySetInnerHTML={{
										__html: ' ' + title,
									}}
								/>
								<br />
							</React.Fragment>
						))}
						<div className={classes.messageBody}>
							{w.messageList.map((msg, i) => (
								<React.Fragment key={i}>
									<span
										dangerouslySetInnerHTML={{
											__html: msg,
										}}
									/>
									<br />
								</React.Fragment>
							))}
						</div>
						{w.contact && (
							<Typography variant="body1" align="right">
								{w.contact}
							</Typography>
						)}
						{(w.isBtnApply !== 0 || w.isBtnResultApply !== 0) && (
							<Grid
								container={true}
								justify="flex-start"
								spacing={3}
								className={classes.buttons}
							>
								{w.isBtnApply !== 0 && (
									<Grid item={true}>
										<this.BtnApply whatsNew={w} />
									</Grid>
								)}
								{w.isBtnResultApply !== 0 && (
									<Grid item={true}>
										<this.BtnResultApply whatsNew={w} />
									</Grid>
								)}
							</Grid>
						)}
					</Paper>
				))}
			</div>
		);
	}

	/**
	 * 受講申請ボタン
	 */
	protected BtnApply: React.FC<{ whatsNew: Actions.IWHatsNew }> = props => {
		if (props.whatsNew.isBtnApply === 2) {
			return (
				<Button variant="outlined" disabled={true}>
					{props.whatsNew.careerTypeID === 10
						? i18n.t('WhatsNewDetail_0001')
						: i18n.t('WhatsNewDetail_0002')}
				</Button>
			);
		}

		return (
			<Link
				to={{
					pathname: Routes.getPath(
						Screens.PERSONAL_LECTURE_APPLICATION
					),
					state: {
						caller: window.location.pathname,
						careerType:
							props.whatsNew.careerTypeID === 10 ? '10' : '0',
						targetCareerId: props.whatsNew.careerID,
					},
				}}
			>
				<Button variant="outlined">
					{props.whatsNew.careerTypeID === 10
						? i18n.t('WhatsNewDetail_0003')
						: i18n.t('WhatsNewDetail_0004')}
				</Button>
			</Link>
		);
	};

	/**
	 * 実績申請ボタン
	 */
	protected BtnResultApply: React.FC<{
		whatsNew: Actions.IWHatsNew;
	}> = props => {
		if (props.whatsNew.isBtnResultApply === 2) {
			return (
				<Button variant="outlined" disabled={true}>
					{i18n.t('WhatsNewDetail_0005')}
				</Button>
			);
		}

		if (props.whatsNew.classID && props.whatsNew.classID !== '') {
			let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_APPLICATION);
			to = to.replace(/\/:career_id/, `/${props.whatsNew.careerID}`);
			to = to.replace(/\/:class_id/, `/${props.whatsNew.classID}`);
			to = to.replace(/\/:nittei_only_flg/, `/0`);
			return (
				<Link
					to={{
						pathname: to,
						state: {
							caller: window.location.pathname,
							skillViewFlg: props.whatsNew.careerTypeID === 10,
						},
					}}
				>
					<Button variant="outlined">
						{i18n.t('WhatsNewDetail_0006')}
					</Button>
				</Link>
			);
		} else {
			return (
				<Link
					to={{
						pathname: Routes.getPath(
							Screens.PERSONAL_LECTURE_APPLICATION
						),
						state: {
							caller: window.location.pathname,
							careerType:
								props.whatsNew.careerTypeID === 10 ? '10' : '0',
							resultApply: true,
							targetCareerId: props.whatsNew.careerID,
						},
					}}
				>
					<Button variant="outlined">
						{i18n.t('WhatsNewDetail_0007')}
					</Button>
				</Link>
			);
		}
	};
}

const mapStateToProps = (state: IRootState) => ({
	whatsNews: state.whatsNewDetail.whatsNews,

	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearWhatsNewList: () => dispatch(Actions.clearWhatsNewList({})),
	fetchWhatsNews: (token: string) => {
		const s = ScenarioFactory.createFetchWhatsNews(dispatch, token);
		s.run({});
	},
});

// tslint:disable-next-line: no-empty-interface
export interface IMessageDetailProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IMessageDetailProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(MessageDetail);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/WhatsNewDetail.tsx